import { queryOptions, useQuery } from '@tanstack/react-query';
import { api } from '@/api/api.ts';

// Types

interface Claim {
  typ: string;
  val: string;
}

interface User {
  clientPrincipal: {
    claims: Claim[];
  };
}

// Query factory

export const userQueries = {
  current: () =>
    queryOptions({
      queryKey: ['user'] as const,
      queryFn: () => api.get<User>('/.auth/me'),
    }),
};

// Hooks

export const useFetchUser = () => {
  return useQuery(userQueries.current());
};
